<ng-container *ngIf="!attributeComponentContext.attribute.hidden">
  <div class="d-sm-flex flex-column date-input">
    <div class="d-sm-flex align-items-start date-input__wrapper">
      <udex-date-picker
        (selection-change)="onSelectionChange($event)"
        *ngIf="isStartDateAttribute() && !shouldBeReadOnly(); else readOnly"
        [disabled]="hasPendingChangesService.hasPendingChanges() | async"
        [label]="'configurator.startDate' | cxTranslate"
        [maxDate]="maxDateString | date: 'YYYY-MM-dd'"
        [minDate]="minDateString | date: 'YYYY-MM-dd'"
        [formatPattern]="dateFormat"
        [supportingText]="getSupportingText()"
        [valueState]="getValueState()"
        [value]="getFormattedMomentDate()"
        class="date-input__component"
        id="{{ createAttributeIdForConfigurator(attribute) }}"
        selection-mode="Single"></udex-date-picker>
      <ng-template #readOnly>
        <div class="udex-mt-12 udex-mt-sm-8 body--s">
          {{ 'configurator.date.startDate' | cxTranslate }}
          <span class="heading__medium--xxxxs">{{ minDateString | date: 'dd MMM yyyy' }}</span>
        </div>
      </ng-template>
      <ng-container *ngIf="endDate?.selectedSingleValue">
        <div class="udex-ms-sm-20 udex-ms-xs-0 udex-mt-8 body--s">
          <p class="end-date-label">
            {{ 'configurator.date.endDate' | cxTranslate }} {{ endDate?.selectedSingleValue | date: 'dd MMM yyyy' }}
          </p>
        </div>
      </ng-container>
    </div>
    <div>
      <ng-container
        *ngIf="endDate && endDate?.validation"
        class="enddate-validation-footer"
        [cxConfiguratorAttributeComponent]="{
          componentKey: 'Footer',
          attribute: endDate,
          owner: attributeComponentContext.owner,
          group: attributeComponentContext.group,
          expMode: attributeComponentContext.expMode,
          language: (activeLanguage$ | async) || '',
          isNavigationToGroupEnabled: false,
        }"></ng-container>
    </div>
  </div>
</ng-container>
